import React from 'react'

function ThreeStickCircleIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z"
        fill="#FA7C00"
      />
      <rect x="14" y="16" width="26" height="6" fill="white" />
      <rect x="14" y="26" width="26" height="6" fill="white" />
      <rect x="14" y="36" width="26" height="6" fill="white" />
    </svg>
  )
}

export default ThreeStickCircleIcon
